import { h, render, Component } from 'preact';
import WidgetLoader from './WidgetLoader';
import {GetTopWidgetName} from '../utils/widgetUtil';
import { Text } from 'preact-i18n';

export default class TopWidget extends Component {
    constructor(props) {
        super(props);
            this.state = {
            widgetInfo: null,
            loadedWidgets: {}
        }
    }
    componentDidMount() {
        if(this.props.searchResp && this.props.searchResp.WidgetInfo) {
            this.setState(c => {
                c.widgetInfo = this.props.searchResp.WidgetInfo;
                return c;
            })
        }
    }
    componentWillUpdate(nextProps) {
        if(!nextProps.searchResp || nextProps.searchResp.WidgetInfo != this.state.widgetInfo) {
            this.setState(c => {
                c.widgetInfo = nextProps.searchResp ? nextProps.searchResp.WidgetInfo : null;
                c.loadedWidgets = {};
                return c;
            });
        }
    }
    setWidgetProp(widgetName, propName, propVal) {
        this.setState(c => {
            if(!c.loadedWidgets[widgetName]) {
                c.loadedWidgets[widgetName] = {};
            }
            c.loadedWidgets[widgetName][propName] = propVal;
            return c;
        });
    }
    render () {
        let widget = GetTopWidgetName("top", this.props.searchResp);
        let wdgName = widget?.name;
        let wdgProps = widget?.props ?? {};
        if(!wdgName || wdgName === "NA" || wdgName === "affsearch") {
            return ("");
        } 
        // else if((wdgName === "affsearch" || this.state.loadedWidgets["map"] && this.state.loadedWidgets["map"].hide)) {
        //     return (
        //         <div id="affSearchHeaderWidget" className="aff-search-widget">
        //             <WidgetLoader name="affsearch"
        //                 {...this.props} {...wdgProps}
        //                 setWidgetProp={this.setWidgetProp.bind(this)}
        //             />
        //         </div>
        //     )
        // } 
        else {
            return (
                <div className="search-result">
                    <div className="search-result-main">
                        <div id="mapWidget" className="map-widget">
                            <div className="ae-caption browseExperience">
                                {this.state.loadedWidgets[wdgName] && this.state.loadedWidgets[wdgName].isLoaded ? (
                                    <Text id="newSearch.browseExperience">Browse.live experience</Text>
                                ):("")}
                            </div>
                            <WidgetLoader name={wdgName}
                                {...this.props} {...wdgProps}
                                setWidgetProp={this.setWidgetProp.bind(this)}
                                showExperience={true}
                            />
                        </div>
                    </div>
                    {/*<div className="search-result-side" id="searchResultSide">
                        <div id="affSearchWidget2" className="aff-search-widget">
                            <WidgetLoader name="affsearch"
                                {...this.props} {...wdgProps}
                                setWidgetProp={this.setWidgetProp.bind(this)}
                            />
                        </div>
                    </div>*/}
                </div>
            );
        }
    } 
}